import { IFilter } from '@/models/filters.model';
import { DEFAULT_LOCALE } from '@/models/localization.model';

export const getFilterValuesRow = (filter: IFilter) => {
  const mappedValues = filter.values?.map((value) => value.locale?.[DEFAULT_LOCALE]?.title)?.slice(0, 3);
  const result = filter.values?.length > 3 ? `${mappedValues?.join(', ')}...` : mappedValues?.join(', ');
  return result;
};

export const getFilterCategoriesRow = (filter: IFilter) => {
  const mappedCategories = filter.categories?.map((category) => category.name)?.slice(0, 3);
  const result = filter.categories?.length > 3 ? `${mappedCategories?.join(', ')}...` : mappedCategories?.join(', ');
  return result;
};
